// ゼンリン住宅地図画像取得時にA3サイズ（1/1000縮尺）で範囲選択するためのサイズ定数
import {
  CRS,
  type LatLng,
  latLngBounds,
  type LatLngBounds,
  point,
} from "leaflet";

const A3_WIDTH = 0.42; // 420mm
const A3_HEIGHT = 0.297; // 297mm
const SCALE = 1000; // 1/1000縮尺 max:1500
const A3_WIDTH_METERS = A3_WIDTH * SCALE;
const A3_HEIGHT_METERS = A3_HEIGHT * SCALE;

// メートル単位で正確なサイズを計算するためEPSG3857（Webメルカトル）座標系でA3矩形を計算
const zenrinComputeA3Bounds = (center: LatLng): LatLngBounds => {
  const projected = CRS.EPSG3857.project(center);
  const swPoint = point(
    projected.x - A3_WIDTH_METERS / 2,
    projected.y - A3_HEIGHT_METERS / 2
  );
  const nePoint = point(
    projected.x + A3_WIDTH_METERS / 2,
    projected.y + A3_HEIGHT_METERS / 2
  );
  return latLngBounds(
    CRS.EPSG3857.unproject(swPoint),
    CRS.EPSG3857.unproject(nePoint)
  );
};

export { zenrinComputeA3Bounds, A3_WIDTH_METERS, A3_HEIGHT_METERS };
